const getToken = () => {
  const token = window.localStorage.getItem('token')
  if (token) {
    return token
  }
  return null
}

/**
 * @param {object} [payload]
 * @param {object} [payload.body]
 * @param {string} [payload.method]
 * @returns
 */
const getHeaders = (payload = { body: null, method: 'GET' }) => {
  const { body, method } = payload

  const headers = new Headers({
    Authorization: `DT-Fenix-Token ${getToken()}`,
  })

  let processedBody = null

  if (body) {
    if (body instanceof FormData) {
      processedBody = body
    } else {
      headers.append('Content-Type', 'application/json')
      processedBody = typeof body === 'string' ? body : JSON.stringify(body)
    }
  }

  return {
    method,
    headers,
    body: processedBody,
  }
}

const save = (data) => {
  return {
    data: data || null,
    error: null,
    success: true,
  }
}

const fail = (error) => {
  return {
    data: null,
    error: error || 'Erro desconhecido',
    success: false,
  }
}

const isCustomResponse = (obj) => {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    'data' in obj &&
    'error' in obj &&
    'success' in obj &&
    typeof obj.success === 'boolean'
  )
}

const handleErrors = (response) => {
  if (response?.status >= 500) {
    const errorMessage = typeof response?.data === 'string' ? response?.data : 'Internal server error'
    throw fail(errorMessage)
  }

  if (typeof response !== 'object') {
    throw fail('response must be an object')
  }

  if (response?.status !== 'OK') {
    if ('message' in response && typeof response.message === 'string') {
      throw fail(response.message)
    }
    if ('errors' in response && Array.isArray(response.errors)) {
      throw fail(response.errors.join(', '))
    }

    throw fail('Ocorreu um erro inesperado')
  }

  return save(response.data)
}

export { fail, getHeaders, getToken, handleErrors, isCustomResponse, save }
